export default function Heading({
  heading,
  description,
}: {
  heading: string;
  description: string;
}) {
  return (
    <div className="border-b">
      <div className="w-full p-4 lg:p-6 max-w-7xl flex flex-col gap-2">
        <h1 className="text-2xl font-bold">{heading}</h1>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
